<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '80vw', 'min-height': '65vh' }"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <span class="text-lg font-semibold">
      {{ 'foundReport.send.title' | transloco }}
    </span>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="grid grid-cols-12 gap-4 p-2">

      <!-- LEFT: Empfänger -->
      <div class="col-span-12 lg:col-span-6 flex flex-col gap-4">

        <!-- Behördenkontakte -->
        <p-panel [pt]="{ header: { style: 'background: var(--p-primary-50)' } }">
          <ng-template pTemplate="header">
            <span class="font-semibold text-sm" style="color: var(--p-primary-500)">{{ 'foundReport.send.authorityContacts' | transloco }}</span>
          </ng-template>
          <div class="flex flex-col gap-3 py-1">
            @if (contactsWithEmail.length > 0) {
              @for (contact of contactsWithEmail; track contact.id) {
                <div class="flex items-center gap-3">
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="isContactSelected(contact.id)"
                    (ngModelChange)="toggleContact(contact.id)"
                    [inputId]="'contact_' + contact.id"
                  />
                  <label [for]="'contact_' + contact.id" class="cursor-pointer text-sm leading-tight">
                    <span class="font-medium">{{ getContactDisplayName(contact) }}</span>
                  </label>
                </div>
              }
            } @else {
              <span class="text-sm text-gray-400 italic">
                {{ 'foundReport.send.noAuthorityContacts' | transloco }}
              </span>
            }
          </div>
        </p-panel>

        <!-- Behördeninformationen -->
        <p-panel [pt]="{ header: { style: 'background: var(--p-primary-50)' } }">
          <ng-template pTemplate="header">
            <span class="font-semibold text-sm" style="color: var(--p-primary-500)">{{ 'foundReport.send.authorityInformation' | transloco }}</span>
          </ng-template>
          <textarea
            pTextarea
            class="w-full"
            rows="4"
            [(ngModel)]="editedAuthorityInformation"
            [placeholder]="'foundReport.send.authorityInformationPlaceholder' | transloco"
          ></textarea>
        </p-panel>

        <!-- Freie E-Mails -->
        <p-panel [pt]="{ header: { style: 'background: var(--p-primary-50)' } }">
          <ng-template pTemplate="header">
            <div class="flex items-center justify-between w-full">
              <span class="font-semibold text-sm" style="color: var(--p-primary-500)">{{ 'foundReport.send.customEmails' | transloco }}</span>
              <p-button
                icon="pi pi-plus"
                [text]="true"
                size="small"
                (click)="addCustomEmail()"
                [pTooltip]="'foundReport.send.addEmail' | transloco"
                tooltipPosition="top"
              />
            </div>
          </ng-template>
          <div class="flex flex-col gap-2 py-1">
            @for (email of customEmails; track $index; let i = $index) {
              <div class="flex items-center gap-2">
                <p-inputgroup class="flex-1">
                  <p-iftalabel>
                    <label [for]="'customEmail_' + i">
                      {{ 'foundReport.send.emailPlaceholder' | transloco }}
                    </label>
                    <input
                      pInputText
                      type="email"
                      [id]="'customEmail_' + i"
                      [value]="email"
                      (input)="updateCustomEmail(i, $any($event.target).value)"
                      [ngClass]="{ '!border-red-500': email.length > 0 && !isValidEmail(email) }"
                      class="w-full"
                    />
                  </p-iftalabel>
                </p-inputgroup>
                @if (email?.trim()!.length) {
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    [rounded]="true"
                    [text]="true"
                    (click)="removeCustomEmail(i)"
                  />
                }
              </div>
            }
          </div>
        </p-panel>

      </div>

      <!-- RIGHT: Medien -->
      <div class="col-span-12 lg:col-span-6 flex flex-col gap-4">

        <p-panel [pt]="{ header: { style: 'background: var(--p-primary-50)' } }">
          <ng-template pTemplate="header">
            <span class="font-semibold text-sm" style="color: var(--p-primary-500)">{{ 'animal.media.headline' | transloco }}</span>
          </ng-template>

          <div class="flex flex-col gap-4 py-1">

            <!-- Upload + aus Bibliothek -->
            <div class="flex flex-wrap gap-2">
              <app-media-upload
                [animal]="animal"
                (mediaUploaded)="onMediaUploaded($event)"
              />
              @if (animalMediaExists) {
                <p-button
                  icon="pi pi-images"
                  [label]="'foundReport.send.addExistingMedia' | transloco"
                  [outlined]="true"
                  (click)="openExistingMediaModal()"
                />
              }
            </div>

            <!-- Vorschau ausgewählter Bilder -->
            @if (selectedMediaModels.length > 0) {
              <div>
                <p class="text-xs text-gray-500 mb-2">
                  {{ selectedMediaModels.length }} {{ 'foundReport.send.mediaSelectedCount' | transloco }}
                </p>
                <div class="flex flex-wrap gap-2">
                  @for (m of selectedMediaModels; track m.id) {
                    <div class="relative w-20 h-20 rounded-lg overflow-hidden shadow-sm border border-gray-200">
                      <app-animal-image-container
                        class="block w-full h-full"
                        [animal]="animal"
                        [id]="m.id"
                        [variant]="'app-preview'"
                      />
                      <button
                        type="button"
                        class="absolute top-0.5 right-0.5 h-5 w-5 rounded-full bg-white/90 flex items-center justify-center shadow hover:bg-red-100 transition-colors"
                        (click)="removeMedia(m.id)"
                      >
                        <i class="pi pi-times text-red-500" style="font-size: 0.6rem"></i>
                      </button>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <span class="text-sm text-gray-400 italic">
                {{ 'foundReport.send.noMediaSelected' | transloco }}
              </span>
            }

          </div>
        </p-panel>

      </div>

    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        (click)="close()"
        icon="pi pi-times"
        [text]="true"
        label="{{ 'modal.cancel' | transloco }}"
        [disabled]="isSending"
      />
      <p-button
        (click)="send()"
        icon="pi pi-send"
        label="{{ 'foundReport.send.sendButton' | transloco }}"
        [disabled]="!canSend"
        [loading]="isSending"
      />
    </div>
  </ng-template>
</p-dialog>

<!-- Bestehende Medien auswählen -->
<p-dialog
  [(visible)]="showExistingMedia"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: '80vw', height: '80vh' }"
  (onHide)="closeExistingMediaModal()"
>
  <ng-template pTemplate="header">
    <span class="text-lg font-semibold">{{ 'animal.media.headline' | transloco }}</span>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 p-4">
      @for (m of animalMedia; track m.id) {
        <button
          type="button"
          class="relative w-full h-[180px] rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
          [class.ring-2]="isExistingMediaSelected(m.id)"
          [class.ring-[var(--p-primary-active-color)]]="isExistingMediaSelected(m.id)"
          (click)="toggleExistingMedia(m.id)"
        >
          <app-animal-image-container
            class="block w-full h-full"
            [animal]="animal"
            [id]="m.id"
            [variant]="'app-preview'"
          />
          @if (isExistingMediaSelected(m.id)) {
            <span
              class="absolute top-2 right-2 h-8 w-8 rounded-full bg-white flex items-center justify-center shadow-md"
            >
              <i class="pi pi-check text-sm" style="color: var(--p-primary-active-color)"></i>
            </span>
          }
        </button>
      }
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        severity="secondary"
        [text]="true"
        [label]="'modal.cancel' | transloco"
        (click)="closeExistingMediaModal()"
      />
      <p-button
        icon="pi pi-check"
        [label]="'modal.add' | transloco"
        (click)="addSelectedExistingMedia()"
        [disabled]="selectedExistingMediaIds.size === 0"
      />
    </div>
  </ng-template>
</p-dialog>
